(function () {

    const navToggle = document.querySelectorAll('.diu-neos-structure-header__molecule-menu-mainNavigation__item');
    const subnavList = document.querySelectorAll('.diu-neos-structure-header__molecule-menu-subNavigation__list');
    const darklayer = document.getElementById('diu-neos-structure-header__dark-layer');
    const flyout = document.getElementById('diu-neos-structure-header__flyout-bg');

    if (navToggle.length > 0 && darklayer && flyout) {
        navToggle.forEach(function (navItem) {
            if (navItem.querySelectorAll('div > div').length > 0) {
                navItem.addEventListener('mouseover', function () {
                    openSubnavigation(navItem);
                });
            } else {
                navItem.addEventListener('mouseover', function () {
                    closeSubnavigation();
                });
            }
        });
    }

    if (flyout && subnavList) {
        flyout.addEventListener('mouseleave', function () {
            closeSubnavigation();
        });
        subnavList.forEach(function (subnavItem) {
            subnavItem.addEventListener('mouseleave', function () {
                closeSubnavigation();
            });
        });
    }

    function closeSubnavigation() {
        flyout.classList.remove('show');
        var openItems = document.querySelectorAll(
            '.diu-neos-structure-header__molecule-menu-mainNavigation__item div.show'
        );
        for (var i = 0; i < openItems.length; i++) {
            openItems[i].classList.remove('show');
        }
        darklayer.classList.remove('show');
    }

    function openSubnavigation(nav_item) {
        flyout.classList.add('show');
        var openItems = document.querySelectorAll(
            '.diu-neos-structure-header__molecule-menu-mainNavigation__item div.show'
        );
        for (var i = 0; i < openItems.length; i++) {
            openItems[i].classList.remove('show');
        }

        nav_item.getElementsByTagName('div')[0].classList.add('show');
        darklayer.classList.add('show');
    }
})();
